import { render, staticRenderFns } from "./EffortReport.vue?vue&type=template&id=65d2f749&scoped=true"
import script from "./EffortReport.vue?vue&type=script&lang=js"
export * from "./EffortReport.vue?vue&type=script&lang=js"
import style0 from "./EffortReport.vue?vue&type=style&index=0&id=65d2f749&prod&lang=scss&scoped=true"
import style1 from "./EffortReport.vue?vue&type=style&index=1&id=65d2f749&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d2f749",
  null
  
)

export default component.exports